/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddDealNoteCommand } from '../models';
// @ts-ignore
import { ClientProjectPlansDto } from '../models';
// @ts-ignore
import { CreateDealCommand } from '../models';
// @ts-ignore
import { CreateDealInstallmentCommand } from '../models';
// @ts-ignore
import { DealAttachmentDto } from '../models';
// @ts-ignore
import { DealBasicDetailsDto } from '../models';
// @ts-ignore
import { DealListDtoPaginatedList } from '../models';
// @ts-ignore
import { DealPaymentSummaryDto } from '../models';
// @ts-ignore
import { DealPaymentsDto } from '../models';
// @ts-ignore
import { DealStage } from '../models';
// @ts-ignore
import { DealTimelineDto } from '../models';
// @ts-ignore
import { DealUnitDto } from '../models';
// @ts-ignore
import { DeleteDealInstallmentCommand } from '../models';
// @ts-ignore
import { InstallmentDetailsDto } from '../models';
// @ts-ignore
import { RecordDealPaymentCommand } from '../models';
// @ts-ignore
import { RecordDealPaymentResponse } from '../models';
// @ts-ignore
import { UpdateDealCommand } from '../models';
// @ts-ignore
import { UpdateDealStageCommand } from '../models';
/**
 * DealsApi - axios parameter creator
 * @export
 */
export const DealsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {number} [clientId] 
         * @param {DealStage} [stage] 
         * @param {boolean} [isActive] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, clientId?: number, stage?: DealStage, isActive?: boolean, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (stage !== undefined) {
                localVarQueryParameter['Stage'] = stage;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsAttachmentIdDelete: async (id: number, attachmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdAttachmentsAttachmentIdDelete', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiDealsIdAttachmentsAttachmentIdDelete', 'attachmentId', attachmentId)
            const localVarPath = `/api/Deals/{id}/attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsAttachmentIdGet: async (id: number, attachmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdAttachmentsAttachmentIdGet', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiDealsIdAttachmentsAttachmentIdGet', 'attachmentId', attachmentId)
            const localVarPath = `/api/Deals/{id}/attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdAttachmentsGet', 'id', id)
            const localVarPath = `/api/Deals/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [dealId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsPost: async (id: number, dealId?: number, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdAttachmentsPost', 'id', id)
            const localVarPath = `/api/Deals/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (dealId !== undefined) { 
                localVarFormParams.append('DealId', dealId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdDelete', 'id', id)
            const localVarPath = `/api/Deals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdGet', 'id', id)
            const localVarPath = `/api/Deals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AddDealNoteCommand} [addDealNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdNotesPost: async (id: number, addDealNoteCommand?: AddDealNoteCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdNotesPost', 'id', id)
            const localVarPath = `/api/Deals/{id}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDealNoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdPaymentsGet', 'id', id)
            const localVarPath = `/api/Deals/{id}/payments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {RecordDealPaymentCommand} [recordDealPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsPaymentIdRecordPost: async (id: number, paymentId: number, recordDealPaymentCommand?: RecordDealPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdPaymentsPaymentIdRecordPost', 'id', id)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('apiDealsIdPaymentsPaymentIdRecordPost', 'paymentId', paymentId)
            const localVarPath = `/api/Deals/{id}/payments/{paymentId}/record`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordDealPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateDealInstallmentCommand} [createDealInstallmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsPost: async (id: number, createDealInstallmentCommand?: CreateDealInstallmentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdPaymentsPost', 'id', id)
            const localVarPath = `/api/Deals/{id}/payments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDealInstallmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsSummaryGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdPaymentsSummaryGet', 'id', id)
            const localVarPath = `/api/Deals/{id}/payments/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdProjectPlansGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdProjectPlansGet', 'id', id)
            const localVarPath = `/api/Deals/{id}/project-plans`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDealCommand} [updateDealCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPut: async (id: number, updateDealCommand?: UpdateDealCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdPut', 'id', id)
            const localVarPath = `/api/Deals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDealCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDealStageCommand} [updateDealStageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdStagePut: async (id: number, updateDealStageCommand?: UpdateDealStageCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdStagePut', 'id', id)
            const localVarPath = `/api/Deals/{id}/stage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDealStageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdTimelineGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdTimelineGet', 'id', id)
            const localVarPath = `/api/Deals/{id}/timeline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdUnitsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsIdUnitsGet', 'id', id)
            const localVarPath = `/api/Deals/{id}/units`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteDealInstallmentCommand} [deleteDealInstallmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsPaymentsIdDelete: async (id: number, deleteDealInstallmentCommand?: DeleteDealInstallmentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsPaymentsIdDelete', 'id', id)
            const localVarPath = `/api/Deals/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDealInstallmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsPaymentsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDealsPaymentsIdGet', 'id', id)
            const localVarPath = `/api/Deals/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDealCommand} [createDealCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsPost: async (createDealCommand?: CreateDealCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDealCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DealsApi - functional programming interface
 * @export
 */
export const DealsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DealsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {number} [clientId] 
         * @param {DealStage} [stage] 
         * @param {boolean} [isActive] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, clientId?: number, stage?: DealStage, isActive?: boolean, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DealListDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsGet(pageNumber, pageSize, searchTerm, projectId, clientId, stage, isActive, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdAttachmentsAttachmentIdDelete(id: number, attachmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdAttachmentsAttachmentIdDelete(id, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdAttachmentsAttachmentIdGet(id: number, attachmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdAttachmentsAttachmentIdGet(id, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdAttachmentsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DealAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdAttachmentsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [dealId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdAttachmentsPost(id: number, dealId?: number, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdAttachmentsPost(id, dealId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DealBasicDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {AddDealNoteCommand} [addDealNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdNotesPost(id: number, addDealNoteCommand?: AddDealNoteCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdNotesPost(id, addDealNoteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdPaymentsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DealPaymentsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdPaymentsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {RecordDealPaymentCommand} [recordDealPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdPaymentsPaymentIdRecordPost(id: number, paymentId: number, recordDealPaymentCommand?: RecordDealPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordDealPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdPaymentsPaymentIdRecordPost(id, paymentId, recordDealPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateDealInstallmentCommand} [createDealInstallmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdPaymentsPost(id: number, createDealInstallmentCommand?: CreateDealInstallmentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdPaymentsPost(id, createDealInstallmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdPaymentsSummaryGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DealPaymentSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdPaymentsSummaryGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdProjectPlansGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientProjectPlansDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdProjectPlansGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDealCommand} [updateDealCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdPut(id: number, updateDealCommand?: UpdateDealCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdPut(id, updateDealCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDealStageCommand} [updateDealStageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdStagePut(id: number, updateDealStageCommand?: UpdateDealStageCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdStagePut(id, updateDealStageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdTimelineGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DealTimelineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdTimelineGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsIdUnitsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DealUnitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsIdUnitsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteDealInstallmentCommand} [deleteDealInstallmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsPaymentsIdDelete(id: number, deleteDealInstallmentCommand?: DeleteDealInstallmentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsPaymentsIdDelete(id, deleteDealInstallmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsPaymentsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallmentDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsPaymentsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDealCommand} [createDealCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDealsPost(createDealCommand?: CreateDealCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDealsPost(createDealCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DealsApi - factory interface
 * @export
 */
export const DealsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DealsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {number} [clientId] 
         * @param {DealStage} [stage] 
         * @param {boolean} [isActive] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, clientId?: number, stage?: DealStage, isActive?: boolean, fromDate?: string, toDate?: string, options?: any): AxiosPromise<DealListDtoPaginatedList> {
            return localVarFp.apiDealsGet(pageNumber, pageSize, searchTerm, projectId, clientId, stage, isActive, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsAttachmentIdDelete(id: number, attachmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDealsIdAttachmentsAttachmentIdDelete(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsAttachmentIdGet(id: number, attachmentId: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiDealsIdAttachmentsAttachmentIdGet(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsGet(id: number, options?: any): AxiosPromise<Array<DealAttachmentDto>> {
            return localVarFp.apiDealsIdAttachmentsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [dealId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdAttachmentsPost(id: number, dealId?: number, file?: File, options?: any): AxiosPromise<string> {
            return localVarFp.apiDealsIdAttachmentsPost(id, dealId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDealsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdGet(id: number, options?: any): AxiosPromise<DealBasicDetailsDto> {
            return localVarFp.apiDealsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AddDealNoteCommand} [addDealNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdNotesPost(id: number, addDealNoteCommand?: AddDealNoteCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiDealsIdNotesPost(id, addDealNoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsGet(id: number, options?: any): AxiosPromise<DealPaymentsDto> {
            return localVarFp.apiDealsIdPaymentsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {RecordDealPaymentCommand} [recordDealPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsPaymentIdRecordPost(id: number, paymentId: number, recordDealPaymentCommand?: RecordDealPaymentCommand, options?: any): AxiosPromise<RecordDealPaymentResponse> {
            return localVarFp.apiDealsIdPaymentsPaymentIdRecordPost(id, paymentId, recordDealPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateDealInstallmentCommand} [createDealInstallmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsPost(id: number, createDealInstallmentCommand?: CreateDealInstallmentCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiDealsIdPaymentsPost(id, createDealInstallmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPaymentsSummaryGet(id: number, options?: any): AxiosPromise<DealPaymentSummaryDto> {
            return localVarFp.apiDealsIdPaymentsSummaryGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdProjectPlansGet(id: number, options?: any): AxiosPromise<Array<ClientProjectPlansDto>> {
            return localVarFp.apiDealsIdProjectPlansGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDealCommand} [updateDealCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdPut(id: number, updateDealCommand?: UpdateDealCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiDealsIdPut(id, updateDealCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDealStageCommand} [updateDealStageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdStagePut(id: number, updateDealStageCommand?: UpdateDealStageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiDealsIdStagePut(id, updateDealStageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdTimelineGet(id: number, options?: any): AxiosPromise<DealTimelineDto> {
            return localVarFp.apiDealsIdTimelineGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsIdUnitsGet(id: number, options?: any): AxiosPromise<Array<DealUnitDto>> {
            return localVarFp.apiDealsIdUnitsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteDealInstallmentCommand} [deleteDealInstallmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsPaymentsIdDelete(id: number, deleteDealInstallmentCommand?: DeleteDealInstallmentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiDealsPaymentsIdDelete(id, deleteDealInstallmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsPaymentsIdGet(id: number, options?: any): AxiosPromise<InstallmentDetailsDto> {
            return localVarFp.apiDealsPaymentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDealCommand} [createDealCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDealsPost(createDealCommand?: CreateDealCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiDealsPost(createDealCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDealsGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsGetRequest
 */
export interface DealsApiApiDealsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DealsApiApiDealsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsGet
     */
    readonly clientId?: number

    /**
     * 
     * @type {DealStage}
     * @memberof DealsApiApiDealsGet
     */
    readonly stage?: DealStage

    /**
     * 
     * @type {boolean}
     * @memberof DealsApiApiDealsGet
     */
    readonly isActive?: boolean

    /**
     * 
     * @type {string}
     * @memberof DealsApiApiDealsGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof DealsApiApiDealsGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for apiDealsIdAttachmentsAttachmentIdDelete operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdAttachmentsAttachmentIdDeleteRequest
 */
export interface DealsApiApiDealsIdAttachmentsAttachmentIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdAttachmentsAttachmentIdDelete
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DealsApiApiDealsIdAttachmentsAttachmentIdDelete
     */
    readonly attachmentId: string
}

/**
 * Request parameters for apiDealsIdAttachmentsAttachmentIdGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdAttachmentsAttachmentIdGetRequest
 */
export interface DealsApiApiDealsIdAttachmentsAttachmentIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdAttachmentsAttachmentIdGet
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DealsApiApiDealsIdAttachmentsAttachmentIdGet
     */
    readonly attachmentId: string
}

/**
 * Request parameters for apiDealsIdAttachmentsGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdAttachmentsGetRequest
 */
export interface DealsApiApiDealsIdAttachmentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdAttachmentsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdAttachmentsPost operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdAttachmentsPostRequest
 */
export interface DealsApiApiDealsIdAttachmentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdAttachmentsPost
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdAttachmentsPost
     */
    readonly dealId?: number

    /**
     * 
     * @type {File}
     * @memberof DealsApiApiDealsIdAttachmentsPost
     */
    readonly file?: File
}

/**
 * Request parameters for apiDealsIdDelete operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdDeleteRequest
 */
export interface DealsApiApiDealsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdGetRequest
 */
export interface DealsApiApiDealsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdNotesPost operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdNotesPostRequest
 */
export interface DealsApiApiDealsIdNotesPostRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdNotesPost
     */
    readonly id: number

    /**
     * 
     * @type {AddDealNoteCommand}
     * @memberof DealsApiApiDealsIdNotesPost
     */
    readonly addDealNoteCommand?: AddDealNoteCommand
}

/**
 * Request parameters for apiDealsIdPaymentsGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdPaymentsGetRequest
 */
export interface DealsApiApiDealsIdPaymentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdPaymentsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdPaymentsPaymentIdRecordPost operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdPaymentsPaymentIdRecordPostRequest
 */
export interface DealsApiApiDealsIdPaymentsPaymentIdRecordPostRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdPaymentsPaymentIdRecordPost
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdPaymentsPaymentIdRecordPost
     */
    readonly paymentId: number

    /**
     * 
     * @type {RecordDealPaymentCommand}
     * @memberof DealsApiApiDealsIdPaymentsPaymentIdRecordPost
     */
    readonly recordDealPaymentCommand?: RecordDealPaymentCommand
}

/**
 * Request parameters for apiDealsIdPaymentsPost operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdPaymentsPostRequest
 */
export interface DealsApiApiDealsIdPaymentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdPaymentsPost
     */
    readonly id: number

    /**
     * 
     * @type {CreateDealInstallmentCommand}
     * @memberof DealsApiApiDealsIdPaymentsPost
     */
    readonly createDealInstallmentCommand?: CreateDealInstallmentCommand
}

/**
 * Request parameters for apiDealsIdPaymentsSummaryGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdPaymentsSummaryGetRequest
 */
export interface DealsApiApiDealsIdPaymentsSummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdPaymentsSummaryGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdProjectPlansGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdProjectPlansGetRequest
 */
export interface DealsApiApiDealsIdProjectPlansGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdProjectPlansGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdPut operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdPutRequest
 */
export interface DealsApiApiDealsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateDealCommand}
     * @memberof DealsApiApiDealsIdPut
     */
    readonly updateDealCommand?: UpdateDealCommand
}

/**
 * Request parameters for apiDealsIdStagePut operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdStagePutRequest
 */
export interface DealsApiApiDealsIdStagePutRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdStagePut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateDealStageCommand}
     * @memberof DealsApiApiDealsIdStagePut
     */
    readonly updateDealStageCommand?: UpdateDealStageCommand
}

/**
 * Request parameters for apiDealsIdTimelineGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdTimelineGetRequest
 */
export interface DealsApiApiDealsIdTimelineGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdTimelineGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsIdUnitsGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsIdUnitsGetRequest
 */
export interface DealsApiApiDealsIdUnitsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsIdUnitsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsPaymentsIdDelete operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsPaymentsIdDeleteRequest
 */
export interface DealsApiApiDealsPaymentsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsPaymentsIdDelete
     */
    readonly id: number

    /**
     * 
     * @type {DeleteDealInstallmentCommand}
     * @memberof DealsApiApiDealsPaymentsIdDelete
     */
    readonly deleteDealInstallmentCommand?: DeleteDealInstallmentCommand
}

/**
 * Request parameters for apiDealsPaymentsIdGet operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsPaymentsIdGetRequest
 */
export interface DealsApiApiDealsPaymentsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DealsApiApiDealsPaymentsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiDealsPost operation in DealsApi.
 * @export
 * @interface DealsApiApiDealsPostRequest
 */
export interface DealsApiApiDealsPostRequest {
    /**
     * 
     * @type {CreateDealCommand}
     * @memberof DealsApiApiDealsPost
     */
    readonly createDealCommand?: CreateDealCommand
}

/**
 * DealsApi - object-oriented interface
 * @export
 * @class DealsApi
 * @extends {BaseAPI}
 */
export class DealsApi extends BaseAPI {
    /**
     * 
     * @param {DealsApiApiDealsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsGet(requestParameters: DealsApiApiDealsGetRequest = {}, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.projectId, requestParameters.clientId, requestParameters.stage, requestParameters.isActive, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdAttachmentsAttachmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdAttachmentsAttachmentIdDelete(requestParameters: DealsApiApiDealsIdAttachmentsAttachmentIdDeleteRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdAttachmentsAttachmentIdDelete(requestParameters.id, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdAttachmentsAttachmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdAttachmentsAttachmentIdGet(requestParameters: DealsApiApiDealsIdAttachmentsAttachmentIdGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdAttachmentsAttachmentIdGet(requestParameters.id, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdAttachmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdAttachmentsGet(requestParameters: DealsApiApiDealsIdAttachmentsGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdAttachmentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdAttachmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdAttachmentsPost(requestParameters: DealsApiApiDealsIdAttachmentsPostRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdAttachmentsPost(requestParameters.id, requestParameters.dealId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdDelete(requestParameters: DealsApiApiDealsIdDeleteRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdGet(requestParameters: DealsApiApiDealsIdGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdNotesPost(requestParameters: DealsApiApiDealsIdNotesPostRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdNotesPost(requestParameters.id, requestParameters.addDealNoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdPaymentsGet(requestParameters: DealsApiApiDealsIdPaymentsGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdPaymentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdPaymentsPaymentIdRecordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdPaymentsPaymentIdRecordPost(requestParameters: DealsApiApiDealsIdPaymentsPaymentIdRecordPostRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdPaymentsPaymentIdRecordPost(requestParameters.id, requestParameters.paymentId, requestParameters.recordDealPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdPaymentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdPaymentsPost(requestParameters: DealsApiApiDealsIdPaymentsPostRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdPaymentsPost(requestParameters.id, requestParameters.createDealInstallmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdPaymentsSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdPaymentsSummaryGet(requestParameters: DealsApiApiDealsIdPaymentsSummaryGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdPaymentsSummaryGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdProjectPlansGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdProjectPlansGet(requestParameters: DealsApiApiDealsIdProjectPlansGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdProjectPlansGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdPut(requestParameters: DealsApiApiDealsIdPutRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdPut(requestParameters.id, requestParameters.updateDealCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdStagePut(requestParameters: DealsApiApiDealsIdStagePutRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdStagePut(requestParameters.id, requestParameters.updateDealStageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdTimelineGet(requestParameters: DealsApiApiDealsIdTimelineGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdTimelineGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsIdUnitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsIdUnitsGet(requestParameters: DealsApiApiDealsIdUnitsGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsIdUnitsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsPaymentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsPaymentsIdDelete(requestParameters: DealsApiApiDealsPaymentsIdDeleteRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsPaymentsIdDelete(requestParameters.id, requestParameters.deleteDealInstallmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsPaymentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsPaymentsIdGet(requestParameters: DealsApiApiDealsPaymentsIdGetRequest, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsPaymentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DealsApiApiDealsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    public apiDealsPost(requestParameters: DealsApiApiDealsPostRequest = {}, options?: AxiosRequestConfig) {
        return DealsApiFp(this.configuration).apiDealsPost(requestParameters.createDealCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
